const steps = [
  {
    element: "#sidebar",
    popover: {
      title: "菜单导航",
      description: "点击菜单可以切换右侧菜单内容",
      position: "right"
    },
    padding: 0
  },
  {
    element: "#toggleSidebar",
    popover: {
      title: "折叠按钮",
      description: "点击收起和展开菜单导航",
      position: "bottom"
    }
  },
  {
    element: "#breadcrumb",
    popover: {
      title: "面包屑导航",
      description: "用于显示当前菜单项的导航路径",
      position: "bottom"
    }
  },
  {
    element: "#userCenter",
    popover: {
      title: "个人中心",
      description: "鼠标悬浮，显示修改密码下拉框",
      // position: "left"
      position: "right"
    },
    padding: 0
  }
];
export default steps;
